export const GET_PROJECTS_REQUEST = 'GET_PROJECTS_REQUEST';
export const GET_PROJECTS_REQUEST_FAILURE = 'GET_PROJECTS_REQUEST_FAILURE';
export const GET_PROJECTS_REQUEST_SUCCESS = 'GET_PROJECTS_REQUEST_SUCCESS';

export const GET_PROJECTS_OF_CLIENT_REQUEST = 'GET_PROJECTS_OF_CLIENT_REQUEST';
export const GET_PROJECTS_OF_CLIENT_REQUEST_FAILURE = 'GET_PROJECTS_OF_CLIENT_REQUEST_FAILURE';
export const GET_PROJECTS_OF_CLIENT_REQUEST_SUCCESS = 'GET_PROJECTS_OF_CLIENT_REQUEST_SUCCESS';
export const GET_PROJECTS_OF_CLIENT_STOP_LOADING = 'GET_PROJECTS_OF_CLIENT_STOP_LOADING';
